export enum AllowedFileTypes {
  PDF = "application/pdf",
  CSV = "text/csv",
  DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  DOC = "application/msword",
  XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  XLS = "application/vnd.ms-excel",
  JPEG = "image/jpeg",
  JPG = "image/jpg",
  PNG = "image/png",
  MP4 = "video/mp4",
  TXT = "text/plain",
}

export const ACCEPTED_FILE_TYPES = Object.values(AllowedFileTypes).join(",");

export const MIME_TYPE_TO_FILE_EXTENSION: Record<AllowedFileTypes, string> = {
  [AllowedFileTypes.PDF]: ".pdf",
  [AllowedFileTypes.JPEG]: ".jpg",
  [AllowedFileTypes.JPG]: ".jpg",
  [AllowedFileTypes.PNG]: ".png",
  [AllowedFileTypes.CSV]: ".csv",
  [AllowedFileTypes.DOC]: ".doc",
  [AllowedFileTypes.DOCX]: ".docx",
  [AllowedFileTypes.XLS]: ".xls",
  [AllowedFileTypes.XLSX]: ".xlsx",
  [AllowedFileTypes.MP4]: ".mp4",
  [AllowedFileTypes.TXT]: ".txt",
};

export const VIEWABLE_FILE_TYPES = [
  AllowedFileTypes.PDF,
  AllowedFileTypes.JPEG,
  AllowedFileTypes.JPG,
  AllowedFileTypes.PNG,
  AllowedFileTypes.MP4,
];

export const IMAGE_FILE_TYPES = [AllowedFileTypes.JPEG, AllowedFileTypes.JPG, AllowedFileTypes.PNG];

export const ACCEPTED_IMAGE_TYPES = IMAGE_FILE_TYPES.join(",");

export const MAX_FILE_SIZE = 100000000; // 100MB
export const MAX_FILE_SIZE_MB = MAX_FILE_SIZE / 1000000;
// Hashing reads the whole file into memory. Lower this if hashing large files slows uploads or downloads.
export const MAX_HASHED_FILE_SIZE = 100000000; // 100MB
